import React, { useContext } from 'react';
import './UslugaCard.css'
import RadioButton from '../RadioButton/RadioButton'
import { Accordion, Card, useAccordionToggle } from 'react-bootstrap';
import AccordionContext from 'react-bootstrap/AccordionContext';

const UslugaCard = (props) => {

    let linkNakonSRazmakom = props.usluga.uslugaLinkList.filter((uslugaLink) => uslugaLink.pozicija === 1)
        .map((uslugaLink, key) =>
        (
            uslugaLink.tipLink === 1 || uslugaLink.tipLink === 5 ?
                <React.Fragment key={key}>
                    {props.usluga.opis !== "" ? <><br /><br /></> : null}
                    {uslugaLink.tekstPrije}
                    <a
                        className="cardLink"
                        href={uslugaLink.link}
                        target={uslugaLink.tipLink === 1 ? "_blank" : "_self"}
                        rel="noopener noreferrer"
                    >
                        {uslugaLink.tekstLink}
                    </a>
                    {uslugaLink.tekstLink !== "" && "."}
                </React.Fragment>
                :
                <React.Fragment key={key}>
                    {props.usluga.opis !== "" ? <><br /><br /></> : null}
                    {uslugaLink.tekstPrije}
                    <span className="zahtjev-tos" onClick={e => props.handleDownloadPdf(e, uslugaLink.idUslugaLink)}>{uslugaLink.tekstLink}</span>.
                </React.Fragment>
        )
        );
    let linkNaPocetku = props.usluga.uslugaLinkList.filter((uslugaLink) => uslugaLink.pozicija === 2)
        .map((uslugaLink, key) =>
            <React.Fragment key={key}>{uslugaLink.tekstPrije} <a className="cardLink" href={uslugaLink.link} target="_blank" rel="noopener noreferrer">{uslugaLink.tekstLink}</a> </React.Fragment>
        );
    let linkNakon = props.usluga.uslugaLinkList.filter((uslugaLink) => uslugaLink.pozicija === 3)
        .map((uslugaLink, key) =>
            <React.Fragment key={key}> {uslugaLink.tekstPrije} <a className="cardLink" href={uslugaLink.link} target="_blank" rel="noopener noreferrer">{uslugaLink.tekstLink}</a>.</React.Fragment>
        );

    let labela = props.usluga.uslugaLinkList.filter((uslugaLink) => uslugaLink.tipLink === 3)
        .map((uslugaLink, key) => {
            return uslugaLink.tekstLink;
        });

    // Get the active key from context to know if this card is expanded
    const currentEventKey = useContext(AccordionContext);
    const isExpanded = currentEventKey === props.usluga.idUsluge;

    const handleHeaderClick = useAccordionToggle(
        props.usluga.idUsluge,
        () => {
            props.handleChange(
                { target: { value: props.usluga.idUsluge, name: 'usluga' } },
                props.usluga.tipPredajeDoc,
                labela
            );
        }
    );
    
    return (
        <div className="col-12 h-100" style={{ marginBottom: "10px", paddingBottom: "5px", paddingLeft: "0px", paddingRight: "0px" }}>
            <Card className="h-100 usluga-card">
                <Card.Header style={{ padding: '0' }}>
                    <RadioButton
                        usluga={props.usluga}
                        pickedUslugaId={props.pickedUslugaId}
                        isExpanded={isExpanded}
                        onHeaderClick={handleHeaderClick}
                    />
                </Card.Header>
                <Accordion.Collapse eventKey={props.usluga.idUsluge}>
                    <Card.Body>
                        <Card.Text className="cardTextStil">
                            <span className="divider"></span>
                            {linkNaPocetku}{props.usluga.opis}{linkNakon}{linkNakonSRazmakom}
                        </Card.Text>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </div>
    )
}

export default UslugaCard
